import { render, staticRenderFns } from "./SpesifikasiEmas.vue?vue&type=template&id=169d8ebe&"
import script from "./SpesifikasiEmas.vue?vue&type=script&lang=js&"
export * from "./SpesifikasiEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports